import React from "react"
import clsx from "clsx"
import AddButtonNew from "../../AddButton/AddButtonNew"
import Switch from "../../Switch/Switch"

class OwnerDetailBuilderRooms extends React.Component {
  constructor(props) {
    super(props)
    this.getRoomIndexById = this.getRoomIndexById.bind(this)
    this.searchRooms = this.searchRooms.bind(this)
    this.handleWeekToggle = this.handleWeekToggle.bind(this)
    this.handleSelectAll = this.handleSelectAll.bind(this)
  }

  toLowerCase(str) {
    return str ? str.toLowerCase() : '';
  }

  getRoomIndexById(id) {
    for (var i = 0, ilen = this.props.rooms.length; i < ilen; i++) {
      if (this.props.rooms[i].id == id) {
        return i;
      }
    }
  }

  searchRooms(dataArray, inputValue) {
    const unselectedRooms = dataArray.filter(room => {
      const existingRoom = this.props.rooms.find(selectedRoom => room.id == selectedRoom.id);
      return !existingRoom;
    }).sort((a, b) => {
      const identifierA = this.toLowerCase(a.identifier);
      const identifierB = this.toLowerCase(b.identifier);
      if (identifierA < identifierB) return -1;
      if (identifierA > identifierB) return 1;
      return 0;
    });

    if (inputValue) {
      const searchTerm = this.toLowerCase(inputValue);
      return unselectedRooms.filter(room => 
        this.toLowerCase(room.identifier).includes(searchTerm)
      );
    }
    return unselectedRooms;
  }

  handleWeekToggle(roomId, week) {
    if (this.props.onUpdateRoomWeeks) {
      const room = this.props.rooms.find(r => r.id === roomId);
      if (room) {
        const currentWeeks = room.weeks_owned || [];
        const newWeeks = currentWeeks.includes(week)
          ? currentWeeks.filter(w => w !== week)
          : [...currentWeeks, week].sort((a, b) => a - b);
        this.props.onUpdateRoomWeeks(roomId, newWeeks);
      }
    }
  }

  handleSelectAll(roomId, checked) {
    if (this.props.onUpdateRoomWeeks) {
      const room = this.props.rooms.find(r => r.id === roomId);
      if (room) {
        const allWeeks = Array.from({length: 52}, (_, i) => i + 1);
        const newWeeks = checked ? allWeeks : [];
        this.props.onUpdateRoomWeeks(roomId, newWeeks);
      }
    }
  }

  renderWeekSelector(room) {
    const weeks = Array.from({length: 52}, (_, i) => i + 1);
    const selectedWeeks = room.weeks_owned || [];
    const allSelected = selectedWeeks.length === 52;

    return (
      <div className="week-selector">
        <div style={{marginBottom: '8px', fontWeight: 'bold', color: '#666'}}>
          {I18n.t('weeks_owned')}
        </div>
        <div className="week-grid" style={{display: 'grid', gridTemplateColumns: 'repeat(13, 1fr)', gap: '5px'}}>
          {weeks.map(week => (
            <button
              key={week}
              type="button"
              className={`btn btn-sm ${selectedWeeks.includes(week) ? 'btn-primary' : 'btn-outline-primary'}`}
              onClick={() => this.handleWeekToggle(room.id, week)}
              style={{padding: '2px 5px', fontSize: '12px'}}
            >
              {week}
            </button>
          ))}
        </div>
        <div style={{marginTop: '10px'}}>
          <Switch
            switchId={`select-all-${room.id}`}
            value={allSelected}
            onChange={(e) => this.handleSelectAll(room.id, e.target.checked)}
            onText="clear_all"
            offText="apply_all"
            additionalClasses="mb-2"
          />
        </div>
      </div>
    );
  }

  renderRooms() {
    if (!this.props.rooms || this.props.rooms.length === 0) {
      return (
        <div className="no-records col-md-12">
          <span className="none">{I18n.t('none')}</span>
        </div>
      )
    }

    return this.props.rooms.map((room) => (
      <div 
        className="row" 
        id={`room-${room.id}`} 
        key={`room-${room.id}`} 
        style={{
          background: "#f8f9fa",
          border: "1px solid #dee2e6",
          borderRadius: '4px',
          flexWrap: "nowrap",
          marginBottom: '15px',
          padding: '15px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
        }}
      >
        <div className="col-md-10"> 
          <div style={{display: 'flex', flexDirection: 'column', gap: '15px'}}>
            <div style={{
              fontWeight: 'bold',
              color: '#495057',
              fontSize: '16px',
              borderBottom: '2px solid #e9ecef',
              paddingBottom: '8px'
            }}>
              {`${I18n.t('room_id')}: ${room.identifier}`}
            </div>
            {this.renderWeekSelector(room)}
          </div>
        </div>
        <div className="col-md-2" style={{display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-end'}}>
          <button 
            type="button" 
            name={room.id} 
            className="btn btn-secondary" 
            onClick={() => this.props.onRemoveRoom(room.id)}
          >
            {I18n.t('remove')}
          </button>
        </div>
      </div>
    ))
  }

  render() {
    const tabClasses = clsx({
      'active': this.props.active_tab === 'rooms',
      'tab-pane': true
    })

    return (
      <div className={tabClasses} id="rooms">
        <div className="row">
          <div className="col-md-12">
            <div className="panel panel-default">
              <div className="panel-heading flexed add-button-pannel" style={{background: '#f8f9fa', borderBottom: '2px solid #dee2e6'}}>
                <div className="col-md-6">
                  <h3 className="panel-title" style={{color: '#495057', margin: '0'}}>
                    {`${I18n.t('room_ids')}*`}
                  </h3>
                </div>
                <div className="col-md-6 content-right flexed">
                  <AddButtonNew
                    model="Room"
                    text={I18n.t('add')}
                    ids={this.props.rooms ? this.props.rooms.map(room => room.id) : []}
                    onAdd={this.props.onAddRoom}
                    buttonClasses="btn btn-primary"
                    generalPosition="left"
                    searchInput={true}
                    searchFunction={this.searchRooms}
                  />
                </div>
              </div>
              <div className="panel-body flexed">
                <div className="container" style={{
                  maxHeight: '500px',
                  overflowY: 'auto',
                  padding: '15px',
                  background: '#fff',
                  borderRadius: '4px'
                }}>
                  {this.renderRooms()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default OwnerDetailBuilderRooms
